var _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlansIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_2_",
    "data-name": "calendar (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.004,
    height: 21.004,
    viewBox: "0 0 21.004 21.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37615",
    "data-name": "Path 37615",
    d: "M16.628,1.75h-.875V.875a.875.875,0,1,0-1.75,0V1.75H7V.875a.875.875,0,1,0-1.75,0V1.75H4.376A4.381,4.381,0,0,0,0,6.126v10.5A4.381,4.381,0,0,0,4.376,21H16.628A4.381,4.381,0,0,0,21,16.628V6.126A4.381,4.381,0,0,0,16.628,1.75ZM1.75,6.126A2.626,2.626,0,0,1,4.376,3.5H16.628a2.626,2.626,0,0,1,2.626,2.626V7H1.75ZM16.628,19.254H4.376A2.626,2.626,0,0,1,1.75,16.628V8.752h17.5v7.877A2.626,2.626,0,0,1,16.628,19.254Z",
    fill: "#ff643a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.313,
    cy: 1.313,
    r: 1.313,
    transform: "translate(9.189 11.815)",
    fill: "#ff643a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1.313,
    cy: 1.313,
    r: 1.313,
    transform: "translate(4.813 11.815)",
    fill: "#ff643a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1.313,
    cy: 1.313,
    r: 1.313,
    transform: "translate(13.565 11.815)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon2);
export default __webpack_public_path__ + "static/media/plans-icon2.e5d0ea7816b55cf61202a710367c5bdf.svg";
export { ForwardRef as ReactComponent };